export default __webpack_public_path__ + "static/media/BT.1d0974b1.svg";